import React from 'react';
import { SelectContainer } from './Select.styled';
import BaselineKeyboardArrowDown24 from 'src/assets/images/BaselineKeyboardArrowDown24.svg';
import SortAscending from 'src/assets/images/SortAscending.svg';
import { logErrorToConsole } from 'src/utils/util';

export default function Select(props) {
   
    return (
        <>
            <SelectContainer
                isFromConsignmentAddProductGuide={props.isFromConsignmentAddProductGuide}
                filter={props.filter ? props.filter : false}
                width={props.width}
                sortIcon={props.sortIcon || SortAscending}
                consignmentBilling={props.consignmentBilling}
                consignmentAdd={props.consignmentAdd}
                height={props.height}
                smWidth={props.smWidth}
              
                marginLeft={props.marginLeft}
                xSmWidth={props.xSmWidth}
                value={props.value}
                options={props.options}
                className={props.className}
                borderColor={props.borderColor}
                onChange={(event) => {
                    const key = event?.originalEvent?.key;
                   
                    
                    if (props.name) {
                        props.onChange({ [props.name]: event.value });
                    }
                    else {
                        props?.isFromProcedure&&  key === 'ArrowDown' || key === 'ArrowUp'?
                        props.onChange(event.value,true):  props.onChange(event.value);
                    }
                       
                }
                }
                onInputChange={(event)=>props.onInputChange(event.value)}
                onFocus={props.onFocus}
                onBlur={props.onBlur}
                optionLabel={props.optionLabel}
                optionValue={props.optionValue}
                placeholder={props.placeholder}
                itemTemplate={props.itemTemplate}
                style={props.style}
                disabled={props.disabled}
                borderRadius={props.borderRadius}
                valueTemplate={props.valueTemplate}
                emptyMessage={props.emptyMessage}
                labelColor={props.labelColor}
                downArrowIcon={BaselineKeyboardArrowDown24}
                selectedLabelFontSize={props.selectedLabelFontSize}
                selectedLabelfontFamily={props.selectedLabelfontFamily}
                showClear={props.showClear}
                scrollHeight={props.scrollHeight}
                onShow={props.onOpen ? props.onOpen : () => { }}
               
                onHide={() => {
                    try {
                    if (props.value&&props?.isFromProcedure) {
                     
                        
                            props.onChange?.(
                               props.value
                                
                            );
                    }
                
                   
                    props.onClose?.();
                } catch (error) {
                    logErrorToConsole(error);
                }
                }}

              
                editable={props.editable}
                crossIconMargin={props.crossIconMargin}
                id={props.id}
                right={props.right}
                marginRight={props.marginRight}
                mbMarginBottom={props.mbMarginBottom}
                mbBorderRadius={props.mbBorderRadius} 
                sortMarginRight={props.sortMarginRight}
                isSortMobileView={props.isSortMobileView}
            />
        </>
    );
}
